"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CategoryHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: dividerRef,
    isVisible: dividerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="1419" id="category-hero" className="relative bg-background text-foreground overflow-hidden py-32 md:py-44 px-5 md:px-8 lg:px-14">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="w-full h-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/kalisch_steel_industrial_poster.png">
          <source src="/img/kalisch_steel_industrial_loop.webm" type="video/webm" />
        </video>
        {}
        <div className="absolute inset-0 bg-background/70" />
        {}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] md:w-[900px] h-[400px] md:h-[500px] pointer-events-none" style={{
        background: "radial-gradient(ellipse, hsla(125, 55%, 24%, 0.15), transparent 70%)"
      }} />
      </div>

      {}
      <span aria-hidden="true" className="absolute top-6 left-6 md:top-10 md:left-10 text-[10px] z-10" style={{
      color: "hsl(125 55% 24%)"
    }}>
        
      </span>
      <span aria-hidden="true" className="absolute top-6 right-6 md:top-10 md:right-10 text-[10px] z-10" style={{
      color: "hsl(125 55% 24%)"
    }}>
        
      </span>
      <span aria-hidden="true" className="absolute bottom-6 left-6 md:bottom-10 md:left-10 text-[10px] z-10" style={{
      color: "hsl(125 55% 24%)"
    }}>
        
      </span>
      <span aria-hidden="true" className="absolute bottom-6 right-6 md:bottom-10 md:right-10 text-[10px] z-10" style={{
      color: "hsl(125 55% 24%)"
    }}>
        
      </span>

      {}
      <div className="relative z-10 mx-auto max-w-6xl flex flex-col items-center text-center">
        {}
        <div ref={eyebrowRef} className={`font-mono text-xs md:text-sm uppercase transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        letterSpacing: "0.18em"
      }}>
          <span style={{
          color: "hsl(19 89% 54%)"
        }}>§</span>{" "}
          <span className="text-foreground/80">01 — Kalisch Acero</span>
        </div>

        {}
        <h1 ref={headlineRef} className="font-default mt-10 md:mt-14 font-bold text-foreground" style={{
        fontSize: "clamp(3.25rem, 8.4vw, 9.5rem)",
        letterSpacing: "-0.035em",
        lineHeight: "0.92"
      }}>
          <span className={`inline-block transition-all duration-700 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: "0ms"
        }}>
            Forjando
          </span>{" "}
          <span className={`inline-block transition-all duration-700 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: "80ms"
        }}>
            el Futuro
          </span>{" "}
          <span className={`inline-block transition-all duration-700 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: "160ms"
        }}>
            del Acero
          </span>{" "}
          <span className="relative inline-block">
            <em className={`not-italic font-default transition-all duration-700 ease-out`} style={{
            color: "hsl(125 55% 24%)",
            letterSpacing: "-0.01em",
            transitionDelay: "240ms",
            opacity: headlineVisible ? 1 : 0,
            transform: headlineVisible ? "translateY(0)" : "translateY(24px)"
          }}>
              Estructural
            </em>
            {}
            <span aria-hidden="true" className="absolute left-0 -bottom-2 md:-bottom-3 h-px flex items-center" style={{
            width: headlineVisible ? "100%" : "0%",
            transition: "width 600ms cubic-bezier(.2,.8,.2,1)",
            transitionDelay: "840ms",
            backgroundColor: "hsl(125 55% 24%)"
          }}>
              <span aria-hidden="true" className="absolute -right-1 w-1.5 h-1.5 rounded-lg" style={{
              backgroundColor: "hsl(19 89% 54%)",
              opacity: headlineVisible ? 1 : 0,
              transition: "opacity 300ms ease-out",
              transitionDelay: "1440ms"
            }} />
            </span>
          </span>
        </h1>

        {}
        <div ref={dividerRef} className={`mt-14 md:mt-20 flex items-center justify-center transition-opacity duration-700 ease-out ${dividerVisible ? "opacity-100" : "opacity-0"}`}>
          <span className="block h-px" style={{
          width: dividerVisible ? "240px" : "0px",
          transition: "width 700ms cubic-bezier(.2,.8,.2,1)",
          backgroundColor: "hsl(125 55% 24%)"
        }} />
          <span className="ml-[-3px] w-1.5 h-1.5 rounded-lg" style={{
          backgroundColor: "hsl(19 89% 54%)",
          opacity: dividerVisible ? 1 : 0,
          transition: "opacity 300ms ease-out 600ms"
        }} />
        </div>

        {}
        <div ref={bodyRef} className={`mt-8 md:mt-10 max-w-2xl transition-all duration-700 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="font-default text-foreground/85" style={{
          fontSize: "clamp(1.0625rem, 1.18vw, 1.25rem)",
          lineHeight: "1.55",
          letterSpacing: "-0.005em"
        }}>
            Líderes en soluciones integrales de acero, estructuras y trefilados. 
            Calidad industrial con un compromiso inquebrantable hacia la sostenibilidad y la innovación.
          </p>
        </div>

        {}
        <div ref={ctaRef} className={`mt-10 md:mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto transition-all duration-700 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild className="group h-14 px-8 rounded-md w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary-600 hover:text-primary-foreground font-default font-semibold uppercase shadow-md transition-colors duration-300" style={{
          letterSpacing: "0.06em",
          fontSize: "14px"
        }}>
            <Link to="/CatalogPage">
              <span>Ver Catálogo</span>
              <ArrowRight className="ml-1 size-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" aria-hidden="true" />
            </Link>
          </Button>

          <Button asChild variant="outline" className="h-14 px-8 rounded-md w-full sm:w-auto bg-transparent border font-default font-semibold uppercase transition-colors duration-300" style={{
          borderColor: "hsl(125 55% 24%)",
          color: "hsl(125 55% 24%)",
          letterSpacing: "0.06em",
          fontSize: "14px"
        }}>
            <Link to="/ProductsPage">Nuestros Productos</Link>
          </Button>
        </div>
      </div>
    </section>;
}